module.exports = __webpack_public_path__ + "static/media/TOR-2CRV.e049ea5e.svg";